import React from 'react';
import { AppBar } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { Configuration } from "../../../configs/Configuration";

const useStyles = makeStyles({
  root: {
    backgroundColor: configColors => `rgb(${configColors['--color_2']})`,
    position: "sticky",
    top: 70,
  }
});

export default function CobrowsingBanner(props){
  const configColors = Configuration.getColors().colors;
  const classes = useStyles(configColors);

  let data = props.translationsData.data;
  let activeText = data["COBROWSING.ACTIVE_TEXT"];
  let customer = data["COBROWSING.CUSTOMER_TEXT"];
  let acctNumber = data["COBROWSING.ACCOUNT_TEXT"];

  return(
    <AppBar className="cobrowsing-root" classes={{root: classes.root}}>
      <div className= "cobrowsing-banner">
        <span className= "cobrowsing-data">{activeText}</span>
        <span>{customer}: </span>
        <span className= "cobrowsing-data">{props.userObject.firstName} {props.userObject.lastName}</span>
        <span>{acctNumber}: </span>
        <span>{props.userObject.partnerUserId}</span>
      </div>
    </AppBar>
  );
}
